// This file is auto-generated by @hey-api/openapi-ts

import type { RequestResult } from '../client';
import { client } from '../client.gen';
import type { Options } from '../sdk.gen';
import type { DownloadUsingGetData, DownloadUsingGetErrors, DownloadUsingGetResponses } from '../types.gen';

export class DesktopDownloadControllerService {
    /**
     * download
     */
    public static downloadUsingGet<ThrowOnError extends boolean = false>(options?: Options<DownloadUsingGetData, ThrowOnError>): RequestResult<DownloadUsingGetResponses, DownloadUsingGetErrors, ThrowOnError> {
        return (options?.client ?? client).get<DownloadUsingGetResponses, DownloadUsingGetErrors, ThrowOnError>({ url: '/v1/desktop/download', ...options });
    }
}
